import { Pipe, PipeTransform } from "@angular/core";

import * as moment from "moment";

@Pipe({ name: "momentFormat" })
export class MomentFormatPipe implements PipeTransform {
    transform(value: moment.MomentInput, format: string) {
        return moment(value).format(format);
    }
}
@Pipe({ name: "LocalDateTime" })
export class LocalDateTimePipe implements PipeTransform {
    transform(value: moment.MomentInput) {
        if (!value) return "";
        return moment(value).format("YYYY-MM-DD HH:mm");
    }
}



// WEBPACK FOOTER //
// ./src/shared/utils/moment-format.pipe.ts